import { render } from "./ShowQrCode.vue?vue&type=template&id=04880da4&scoped=true&ts=true"
import script from "./ShowQrCode.vue?vue&type=script&lang=ts"
export * from "./ShowQrCode.vue?vue&type=script&lang=ts"

import "./ShowQrCode.vue?vue&type=style&index=0&id=04880da4&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04880da4"]])

export default __exports__